import React from 'react';

import { Icon, Label, Pivot, PivotItem } from '@fluentui/react';
import { Text } from '@fluentui/react';
import { DatePickerInput } from '../../lib/FormValidator/Form/DatePickerInput';
import { HourSelector } from '../Common/HourSelector';
import ToggleInput from '../../lib/FormValidator/Form/ToggleInput';
import { useCustomInput } from '../../common/custom-hooks/useCustomInput';
import PlanillaPartidoOfflineForm from './PlanillaPartidoOfflineForm';
import InputField from '../../lib/FormValidator/Form/InputField';
import ArbitroOfflineForm from './ArbitroOfflineForm';
import PartidoOfflineForm from './PartidoOfflineForm';
import TorneoOfflineForm from './TorneoOfflineform';
import OficialDeMesaOfflineForm from './OficialDeMesaOfflineForm';
import ConfeccionPlanillaPartidoTeamOffline from './ConfeccionPlanillaPartidoTeamOffline';
import SystemClient from '../../system/SystemClient';
import ComboBoxInput from '../../lib/FormValidator/Form/ComboBoxInput';
import ArbitroSecundarioOfflineForm from './ArbitroSecundarioOfflineForm';

interface IPlanillaPartidoOfflineViewProps {
  onBlurCustomInput: () => void;
  form: PlanillaPartidoOfflineForm;
  system: SystemClient;
  changeBlockUI: (state: boolean) => void;
}

const PlanillaPartidoOfflineView = ({
  onBlurCustomInput,
  form,
  system,
  changeBlockUI,
}: IPlanillaPartidoOfflineViewProps) => {
  // ==========================================================================================
  // =================================== Forms e Inputs =======================================
  // ==========================================================================================

  const fechaHoraInicioInput = useCustomInput(() => form.getFechaHoraInicioInput(), [form]);
  // const diferidoInput = useCustomInput(() => form.getDiferidoInput(), [form]);
  const campoDeJuegoInput = useCustomInput(() => form.getCampoDeJuegoInput(), [form]);

  const partidoForm: PartidoOfflineForm = form.getPartidoForm();
  const partidoClubLocalInput = useCustomInput(() => partidoForm.getClubLocalInput(), [partidoForm]);
  const partidoClubVisitanteInput = useCustomInput(() => partidoForm.getClubVisitanteInput(), [partidoForm]);

  const torneoForm: TorneoOfflineForm = form.getPartidoForm().getTorneoForm();
  const torneoNombreInput = useCustomInput(() => torneoForm.getNombreInput(), [torneoForm]);
  const torneoCatInput = useCustomInput(() => torneoForm.getCatInput(), [torneoForm]);
  const torneoDivInput = useCustomInput(() => torneoForm.getDivInput(), [torneoForm]);
  const torneoRamaInput = useCustomInput(() => torneoForm.getRamaInput(), [torneoForm]);
  const torneoCantPerInput = useCustomInput(() => torneoForm.getCantPerInput(), [torneoForm]);
  const torneoDurPerInput = useCustomInput(() => torneoForm.getDurPerInput(), [torneoForm]);
  const torneoEmpInput = useCustomInput(() => torneoForm.getEmpInput(), [torneoForm]);
  const torneoCantTeInput = useCustomInput(() => torneoForm.getCantTeInput(), [torneoForm]);
  const torneoDurTeInput = useCustomInput(() => torneoForm.getDurTeInput(), [torneoForm]);

  const arbitro1Form: ArbitroOfflineForm = form.getArbitro1Form();
  const arbitro1TipoDocInput = useCustomInput(() => arbitro1Form.getTipoDocInput(), [arbitro1Form]);
  const arbitro1NroDocInput = useCustomInput(() => arbitro1Form.getNroDocInput(), [arbitro1Form]);
  const arbitro1NombreInput = useCustomInput(() => arbitro1Form.getNombreInput(), [arbitro1Form]);
  const arbitro1ApellidoInput = useCustomInput(() => arbitro1Form.getApellidoInput(), [arbitro1Form]);

  const arbitro2Form: ArbitroSecundarioOfflineForm = form.getArbitro2Form();
  const arbitro2TipoDocInput = useCustomInput(() => arbitro2Form.getTipoDocInput(), [arbitro2Form]);
  const arbitro2NroDocInput = useCustomInput(() => arbitro2Form.getNroDocInput(), [arbitro2Form]);
  const arbitro2NombreInput = useCustomInput(() => arbitro2Form.getNombreInput(), [arbitro2Form]);
  const arbitro2ApellidoInput = useCustomInput(() => arbitro2Form.getApellidoInput(), [arbitro2Form]);

  const oficialDeMesaLocalForm: OficialDeMesaOfflineForm = form.getOficialDeMesaLocalForm();
  const oficialDeMesaLocalNroDocInput = useCustomInput(
    () => oficialDeMesaLocalForm.getNroDocInput(),
    [oficialDeMesaLocalForm]
  );
  const oficialDeMesaLocalNombreInput = useCustomInput(
    () => oficialDeMesaLocalForm.getNombreInput(),
    [oficialDeMesaLocalForm]
  );
  const oficialDeMesaLocalApellidoInput = useCustomInput(
    () => oficialDeMesaLocalForm.getApellidoInput(),
    [oficialDeMesaLocalForm]
  );

  const oficialDeMesaVisitanteForm: OficialDeMesaOfflineForm = form.getOficialDeMesaVisitanteForm();
  const oficialDeMesaVisitanteNroDocInput = useCustomInput(
    () => oficialDeMesaVisitanteForm.getNroDocInput(),
    [oficialDeMesaVisitanteForm]
  );
  const oficialDeMesaVisitanteNombreInput = useCustomInput(
    () => oficialDeMesaVisitanteForm.getNombreInput(),
    [oficialDeMesaVisitanteForm]
  );
  const oficialDeMesaVisitanteApellidoInput = useCustomInput(
    () => oficialDeMesaVisitanteForm.getApellidoInput(),
    [oficialDeMesaVisitanteForm]
  );

  // ==========================================================================================
  // ==========================================================================================
  // ==========================================================================================

  const tipoDocumentoOptions = [
    { key: '1', text: 'DNI' },
    { key: '2', text: 'Pasaporte' },
  ];

  const ramaOptions = [
    { key: 'F', text: 'Femenino' },
    { key: 'M', text: 'Masculino' },
  ];

  return (
    <>
      {/* {console.log(form)} */}
      <div>
        <div className="ms-Grid mt-2 bg-white-h100 ms-depth-4 ml-2 mr-2" dir="ltr">
          <div className="ms-Grid-row padding-1 mb-2">
            <Pivot aria-label="">
              <PivotItem headerText="Básicos" itemKey={'Basicos'}>
                <div style={{ marginBottom: 10 }}>
                  <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row form-row-container">
                      <div className="ms-Grid-col ms-lg12 ms-xl6">
                        <div className="multiple-box-row-container">
                          <div className="ms-Grid bg-white-h100 ms-depth-4" dir="ltr">
                            <div className="ms-Grid-row padding-1">
                              {form && (
                                <div className="ms-Grid-col ms-sm12">
                                  <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12 ">
                                      <Text variant={'large'} className={'player-detail-section-title'}>
                                        <Icon iconName="WorldClock" className="text-icon" />
                                        Lugar y Fecha
                                      </Text>
                                    </div>
                                  </div>
                                  <div className="ms-Grid-row mt-2">
                                    <div className="ms-Grid-col ms-sm6 ">
                                      <InputField
                                        input={campoDeJuegoInput}
                                        label="Campo de juego (*)"
                                        onBlur={onBlurCustomInput}
                                      />
                                    </div>
                                    <div className="ms-Grid-col ms-sm3">
                                      <DatePickerInput
                                        input={fechaHoraInicioInput}
                                        label={'Fecha (*)'}
                                        onBlur={onBlurCustomInput}
                                      />
                                    </div>
                                    <div className="ms-Grid-col ms-sm3">
                                      <HourSelector
                                        onChange={(val) => {
                                          if (form.getHorario() !== val) {
                                            const copiaFecha = new Date(fechaHoraInicioInput.getValue());
                                            copiaFecha.setHours(+val.split(':')[0]);
                                            copiaFecha.setMinutes(+val.split(':')[1]);
                                            fechaHoraInicioInput.setValue(copiaFecha);
                                            onBlurCustomInput();
                                          }
                                        }}
                                        hour={+form.getHorario().split(':')[0]}
                                        minute={+form.getHorario().split(':')[1]}
                                        useHalf
                                        useLabel
                                        required
                                      />
                                    </div>
                                  </div>
                                  {/* <div className="ms-Grid-row mt-2">
                          <div className="ms-Grid-col ms-sm3">
                            <Label>En vivo</Label>
                            <ToggleInput
                              input={diferidoInput}
                              onBlur={onBlurCustomInput}
                              offText={'No'}
                              onText={'Si'}
                            ></ToggleInput>
                          </div>
                        </div> */}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="ms-Grid bg-white-h100 ms-depth-4 mt-2" dir="ltr">
                            <div className="ms-Grid-row padding-1">
                              {form && (
                                <div className="ms-Grid-col ms-sm12">
                                  <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12 ">
                                      <Text variant={'large'} className={'player-detail-section-title'}>
                                        <Icon iconName="Trophy" className="text-icon" />
                                        Torneo y Categoría
                                      </Text>
                                    </div>
                                  </div>
                                  <div className="ms-Grid-row mt-2">
                                    <div className="ms-Grid-col ms-sm6">
                                      <InputField
                                        input={torneoNombreInput}
                                        label="Nombre (*)"
                                        onBlur={onBlurCustomInput}
                                      />
                                    </div>
                                    <div className="ms-Grid-col ms-sm3">
                                      <ComboBoxInput
                                        input={torneoRamaInput}
                                        label="Rama (*)"
                                        onBlur={onBlurCustomInput}
                                        options={ramaOptions}
                                        selectedKey={torneoRamaInput.getValue()}
                                      />
                                    </div>
                                  </div>
                                  <div className="ms-Grid-row mt-2">
                                    <div className="ms-Grid-col ms-sm6">
                                      <InputField
                                        input={torneoCatInput}
                                        label="Categoría (*)"
                                        onBlur={onBlurCustomInput}
                                      />
                                    </div>
                                    <div className="ms-Grid-col ms-sm3">
                                      <InputField
                                        input={torneoDivInput}
                                        label="División (*)"
                                        onBlur={onBlurCustomInput}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-lg12 ms-xl6">
                        <div className="ms-Grid bg-white-h100 ms-depth-4" dir="ltr">
                          <div className="ms-Grid-row padding-1">
                            {form && (
                              <div className="ms-Grid-col ms-sm12">
                                <div className="ms-Grid-row">
                                  <div className="ms-Grid-col ms-sm12 ">
                                    <Text variant={'large'} className={'player-detail-section-title'}>
                                      <Icon iconName="Shield" className="text-icon" />
                                      Equipos
                                    </Text>
                                  </div>
                                </div>
                                <div className="ms-Grid-row mt-2">
                                  <div className="ms-Grid-col ms-sm6 ">
                                    <InputField
                                      input={partidoClubLocalInput}
                                      label="Club local (*)"
                                      onBlur={onBlurCustomInput}
                                    />
                                  </div>
                                  <div className="ms-Grid-col ms-sm6">
                                    <InputField
                                      input={partidoClubVisitanteInput}
                                      label="Club visitante (*)"
                                      onBlur={onBlurCustomInput}
                                    />
                                  </div>
                                </div>
                                <div className="ms-Grid-row mt-2">
                                  <div className="ms-Grid-col ms-sm6">
                                    <Text
                                      className="mb-1"
                                      variant="medium"
                                      style={{ fontWeight: 600, fontSize: 16 }}
                                    >
                                      Oficial de mesa local
                                    </Text>
                                    <div className="ms-Grid-row mt-2">
                                      <div className="ms-Grid-col ms-sm6">
                                        <InputField
                                          input={oficialDeMesaLocalApellidoInput}
                                          label="Apellido (*)"
                                          onBlur={onBlurCustomInput}
                                        />
                                      </div>
                                      <div className="ms-Grid-col ms-sm6">
                                        <InputField
                                          input={oficialDeMesaLocalNombreInput}
                                          label="Nombre (*)"
                                          onBlur={onBlurCustomInput}
                                        />
                                      </div>
                                    </div>
                                    <div className="ms-Grid-row">
                                      <div className="ms-Grid-col ms-sm6">
                                        <InputField
                                          input={oficialDeMesaLocalNroDocInput}
                                          label="Numero documento (*)"
                                          onBlur={onBlurCustomInput}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="ms-Grid-col ms-sm6">
                                    <Text
                                      className="mb-1"
                                      variant="medium"
                                      style={{ fontWeight: 600, fontSize: 16 }}
                                    >
                                      Oficial de mesa visitante
                                    </Text>
                                    <div className="ms-Grid-row mt-2">
                                      <div className="ms-Grid-col ms-sm6">
                                        <InputField
                                          input={oficialDeMesaVisitanteApellidoInput}
                                          label="Apellido (*)"
                                          onBlur={onBlurCustomInput}
                                        />
                                      </div>
                                      <div className="ms-Grid-col ms-sm6">
                                        <InputField
                                          input={oficialDeMesaVisitanteNombreInput}
                                          label="Nombre (*)"
                                          onBlur={onBlurCustomInput}
                                        />
                                      </div>
                                    </div>
                                    <div className="ms-Grid-row">
                                      <div className="ms-Grid-col ms-sm6">
                                        <InputField
                                          input={oficialDeMesaVisitanteNroDocInput}
                                          label="Numero documento (*)"
                                          onBlur={onBlurCustomInput}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="ms-Grid-row mt-2">
                      <div className="ms-Grid-col ms-lg12 ms-xl6">
                        <div className="ms-Grid bg-white-h100 ms-depth-4" dir="ltr">
                          <div className="ms-Grid-row padding-1">
                            {form && (
                              <div className="ms-Grid-col ms-sm12">
                                <div className="ms-Grid-row">
                                  <div className="ms-Grid-col ms-sm12 ">
                                    <Text variant={'large'} className={'player-detail-section-title'}>
                                      <Icon iconName="Group" className="text-icon" />
                                      Arbitros
                                    </Text>
                                  </div>
                                </div>
                                <div className="ms-Grid-row mt-2">
                                  <div className="ms-Grid-col ms-sm12">
                                    <Text
                                      className="mb-1"
                                      variant="medium"
                                      style={{ fontWeight: 600, fontSize: 16 }}
                                    >
                                      Primer arbitro
                                    </Text>

                                    <div className="ms-Grid-row align-flex-end">
                                      <div className="ms-Grid-col ms-sm3">
                                        <InputField
                                          input={arbitro1ApellidoInput}
                                          label="Apellido (*)"
                                          onBlur={onBlurCustomInput}
                                        />
                                      </div>
                                      <div className="ms-Grid-col ms-sm3">
                                        <InputField
                                          input={arbitro1NombreInput}
                                          label="Nombre (*)"
                                          onBlur={onBlurCustomInput}
                                        />
                                      </div>
                                      <div className="ms-Grid-col ms-sm3">
                                        <ComboBoxInput
                                          input={arbitro1TipoDocInput}
                                          label="Tipo documento (*)"
                                          onBlur={onBlurCustomInput}
                                          options={tipoDocumentoOptions}
                                          selectedKey={arbitro1TipoDocInput.getValue()}
                                        />
                                      </div>
                                      <div className="ms-Grid-col ms-sm3">
                                        <InputField
                                          input={arbitro1NroDocInput}
                                          label="Numero documento (*)"
                                          onBlur={onBlurCustomInput}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="ms-Grid-row mt-2">
                                  <div className="ms-Grid-col ms-sm12">
                                    <Text
                                      className="mb-1"
                                      variant="medium"
                                      style={{ fontWeight: 600, fontSize: 16 }}
                                    >
                                      Segundo arbitro
                                    </Text>
                                    <div className="ms-Grid-row align-flex-end">
                                      <div className="ms-Grid-col ms-sm3">
                                        <InputField
                                          input={arbitro2ApellidoInput}
                                          label="Apellido"
                                          onBlur={onBlurCustomInput}
                                        />
                                      </div>
                                      <div className="ms-Grid-col ms-sm3">
                                        <InputField
                                          input={arbitro2NombreInput}
                                          label="Nombre"
                                          onBlur={onBlurCustomInput}
                                        />
                                      </div>
                                      <div className="ms-Grid-col ms-sm3">
                                        <ComboBoxInput
                                          input={arbitro2TipoDocInput}
                                          label="Tipo documento"
                                          onBlur={onBlurCustomInput}
                                          options={tipoDocumentoOptions}
                                          selectedKey={arbitro2TipoDocInput.getValue()}
                                        />
                                      </div>
                                      <div className="ms-Grid-col ms-sm3">
                                        <InputField
                                          input={arbitro2NroDocInput}
                                          label="Numero documento"
                                          onBlur={onBlurCustomInput}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="ms-Grid-col ms-lg12 ms-xl6">
                        <div className="ms-Grid bg-white-h100 ms-depth-4" dir="ltr">
                          <div className="ms-Grid-row padding-1">
                            {form && (
                              <div className="ms-Grid-col ms-sm12">
                                <div className="ms-Grid-row">
                                  <div className="ms-Grid-col ms-sm12 ">
                                    <Text variant={'large'} className={'player-detail-section-title'}>
                                      <Icon iconName="Settings" className="text-icon" />
                                      Configuración Partido
                                    </Text>
                                  </div>
                                </div>
                                <div className="mt-2">
                                  <Text variant="medium" style={{ fontWeight: 600, fontSize: 16 }}>
                                    Tiempo regular
                                  </Text>
                                </div>
                                <div className="ms-Grid-row mt-2">
                                  <div className="ms-Grid-col ms-sm3">
                                    <InputField
                                      input={torneoCantPerInput}
                                      label="Cant. de periodos (*)"
                                      onBlur={onBlurCustomInput}
                                    />
                                  </div>
                                  <div className="ms-Grid-col ms-sm3">
                                    <InputField
                                      input={torneoDurPerInput}
                                      label="Dur. de periodos (*)"
                                      onBlur={onBlurCustomInput}
                                    />
                                  </div>
                                  <div className="ms-Grid-col ms-sm6">
                                    <Label>El resultado final del partido, puede ser empate?</Label>
                                    <ToggleInput
                                      input={torneoEmpInput}
                                      offText="No"
                                      onText="Si"
                                      onBlur={onBlurCustomInput}
                                    />
                                  </div>
                                </div>
                                {!torneoEmpInput.getValue() && (
                                  <div className="mt-2">
                                    <Text variant="medium" style={{ fontWeight: 600, fontSize: 16 }}>
                                      Tiempo extra
                                    </Text>
                                    <div className="ms-Grid-row vertical-center mt-2">
                                      <>
                                        <div className="ms-Grid-col ms-sm3">
                                          <InputField
                                            input={torneoCantTeInput}
                                            label="Cant. de periodos (*)"
                                            onBlur={() => {
                                              onBlurCustomInput();
                                              console.log('INPUT EVALUATE');
                                              torneoCantTeInput.evaluate();
                                              // form.getPartidoForm().getTorneoForm().evaluate();
                                            }}
                                          />
                                        </div>
                                        <div className="ms-Grid-col ms-sm3">
                                          <InputField
                                            input={torneoDurTeInput}
                                            label="Dur. de periodos (*)"
                                            onBlur={onBlurCustomInput}
                                          />
                                        </div>
                                      </>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </PivotItem>
              <PivotItem headerText="Local" itemKey={'Local'}>
                <ConfeccionPlanillaPartidoTeamOffline
                  form={form}
                  onBlurCustomInput={onBlurCustomInput}
                  changeBlockUI={changeBlockUI}
                  system={system}
                  equipoId={form.getEquipoLocalIdInput().getValue()}
                  club_nombre={form.getPartidoForm().getClubLocalInput().getValue() || 'Club local'}
                />
              </PivotItem>
              <PivotItem headerText="Visitante" itemKey={'Visitante'}>
                <ConfeccionPlanillaPartidoTeamOffline
                  form={form}
                  onBlurCustomInput={onBlurCustomInput}
                  changeBlockUI={changeBlockUI}
                  system={system}
                  equipoId={form.getEquipoVisitanteIdInput().getValue()}
                  club_nombre={form.getPartidoForm().getClubVisitanteInput().getValue() || 'Club visitante'}
                />
              </PivotItem>
            </Pivot>
          </div>
        </div>
      </div>
    </>
  );
};

export default PlanillaPartidoOfflineView;
